export default function EstimateIconOutlined() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="3.5"
        stroke="#434343"
      />
      <path
        d="M2.43562 7.74773C2.75824 7.49725 3.34036 7.12101 3.91486 6.85717C5.10163 6.31211 6.70985 6.12009 8.55332 7.39743C9.85936 8.30237 10.9303 8.14706 11.7204 7.79053C12.375 7.49516 13.4841 6.46657 13.7867 6.14258L13.7892 8.86975C13.4631 9.12852 12.9323 9.49727 12.3483 9.7608C11.1501 10.3014 9.50804 10.4973 7.66228 9.21839C6.35395 8.31186 5.31903 8.47093 4.55246 8.823C3.87363 9.13476 2.98418 9.64792 2.4292 10.2861L2.43562 7.74773Z"
        fill="#434343"
      />
    </svg>
  );
}
